import { render } from "./Zijin.vue?vue&type=template&id=769ee9c9"
import script from "./Zijin.vue?vue&type=script&lang=js"
export * from "./Zijin.vue?vue&type=script&lang=js"

import "./Zijin.vue?vue&type=style&index=0&id=769ee9c9&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__